"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonSize = exports.ButtonTypes = void 0;
var ButtonTypes;
(function (ButtonTypes) {
    ButtonTypes["Emphasis"] = "emphasis";
    ButtonTypes["Default"] = "default";
    ButtonTypes["Secondary"] = "secondary";
    ButtonTypes["Tertiary"] = "tertiary";
    ButtonTypes["Text"] = "text";
    ButtonTypes["Danger"] = "danger";
    ButtonTypes["DangerLite"] = "danger-lite";
    ButtonTypes["DangerTertiary"] = "danger-tertiary";
    /* eslint-disable @typescript-eslint/naming-convention */
    /** @deprecated Use ButtonTypes.Emphasis instead */
    ButtonTypes["emphasis"] = "emphasis";
    /** @deprecated Use ButtonTypes.Default instead */
    ButtonTypes["default"] = "default";
    /** @deprecated Use ButtonTypes.Secondary instead */
    ButtonTypes["secondary"] = "secondary";
    /** @deprecated Use ButtonTypes.Text instead */
    ButtonTypes["text"] = "text";
    /** @deprecated Use ButtonTypes.Danger instead */
    ButtonTypes["danger"] = "danger";
    /** @deprecated Use ButtonTypes.DangerLite instead */
    ButtonTypes["danger-lite"] = "danger-lite";
    /* eslint-enable @typescript-eslint/naming-convention */
})(ButtonTypes = exports.ButtonTypes || (exports.ButtonTypes = {}));
var ButtonSize;
(function (ButtonSize) {
    ButtonSize["Small"] = "small";
    ButtonSize["Large"] = "large";
})(ButtonSize = exports.ButtonSize || (exports.ButtonSize = {}));
//# sourceMappingURL=types.js.map